import * as Yup from "yup";
import { DIAS } from "../../Constants/Admin";

export const FormPromoScheme = () => {
  return Yup.object().shape({
    dia: Yup.string().oneOf(DIAS, "Elige un día").required("El campo es requerido"),
    descripcion: Yup.string()
      .required("El campo es requerido")
      .trim()
      .max(200, "Máximo 200 caracteres"),
    precio: Yup.string()
      .required("El campo es requerido")
      .trim()
      .matches(/^\d+(\.\d{1,2})?$/, "Solo números (ej. 239)"),
    incluye: Yup.array().of(Yup.string()).max(6, "Máximo 6 productos"),
    activa: Yup.boolean(),
  });
};
